/* eslint no-param-reassign:off */

export default function initializeCKEditor(editor, richTextData, childrenData) {
  childrenData.forEach(({ id, htmlData }) => {
    editor.execute('registerLibraryItem', { id, rendered: htmlData });
  });
  editor.setData(richTextData);
}
